import { features } from '@/mocks/homeData';

export default function FeaturesGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-14">
          <p className="text-sm font-label tracking-widest uppercase text-foreground-400 mb-4">
            Why Buyers Trust Us
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight">
            Everything You Need<br />to Shop Smarter
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/50 hover:border-background-300/60 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}